import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/");
      return;
    }
    const session_id = m[1];
    const role = sessionStorage.getItem("sa_signup_role") || "client";
    sessionStorage.removeItem("sa_signup_role");

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id, role });
        setUser(res.data.user);
        // Clean URL fragment
        window.history.replaceState(null, "", "/");
        if (res.data.user.role === "admin") navigate("/admin");
        else if (res.data.user.role === "model") navigate("/dashboard/model");
        else navigate("/dashboard");
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="font-serif text-2xl">Iniciando sesión…</div>
        <div className="text-[#6B6A63] mt-2 text-sm">Validando tu acceso</div>
      </div>
    </div>
  );
};

export default AuthCallback;
